import React from 'react';

export function SurveySeasonIllustration() {
  return (
    <svg
      width="160"
      height="120"
      viewBox="0 0 160 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="presentation"
    >
      <ellipse cx="80" cy="108" rx="56" ry="4" fill="#D8F3EA" />

      <rect x="32" y="34" width="78" height="58" rx="4" fill="#FFFFFF" stroke="#7DD3B7" strokeWidth="1.5" />
      <rect x="32" y="34" width="78" height="10" rx="4" fill="#D8F3EA" />
      <circle cx="38" cy="39" r="1.4" fill="#7DD3B7" />
      <circle cx="43" cy="39" r="1.4" fill="#7DD3B7" />
      <circle cx="48" cy="39" r="1.4" fill="#7DD3B7" />

      <rect x="40" y="52" width="26" height="32" rx="2" fill="#EAF8F2" stroke="#7DD3B7" strokeWidth="1.2" />
      <line x1="44" y1="58" x2="62" y2="58" stroke="#7DD3B7" strokeWidth="1.2" strokeLinecap="round" />
      <line x1="44" y1="63" x2="58" y2="63" stroke="#7DD3B7" strokeWidth="1.2" strokeLinecap="round" />
      <line x1="44" y1="68" x2="60" y2="68" stroke="#7DD3B7" strokeWidth="1.2" strokeLinecap="round" />
      <line x1="44" y1="73" x2="56" y2="73" stroke="#7DD3B7" strokeWidth="1.2" strokeLinecap="round" />
      <line x1="44" y1="78" x2="60" y2="78" stroke="#7DD3B7" strokeWidth="1.2" strokeLinecap="round" />

      <rect x="72" y="52" width="32" height="14" rx="2" fill="#EAF8F2" stroke="#7DD3B7" strokeWidth="1.2" />
      <path d="M75 62 L82 57 L88 60 L96 54 L101 58" stroke="#7DD3B7" strokeWidth="1.4" fill="none" strokeLinecap="round" strokeLinejoin="round" />

      <rect x="72" y="70" width="32" height="14" rx="2" fill="#EAF8F2" stroke="#7DD3B7" strokeWidth="1.2" />
      <rect x="76" y="74" width="4" height="7" fill="#7DD3B7" />
      <rect x="83" y="76" width="4" height="5" fill="#7DD3B7" />
      <rect x="90" y="73" width="4" height="8" fill="#7DD3B7" />
      <rect x="97" y="77" width="4" height="4" fill="#7DD3B7" />

      <rect x="14" y="22" width="22" height="28" rx="2" transform="rotate(-12 14 22)" fill="#FFFFFF" stroke="#7DD3B7" strokeWidth="1.2" />
      <line x1="18" y1="28" x2="32" y2="25" stroke="#7DD3B7" strokeWidth="1" strokeLinecap="round" transform="rotate(-12 14 22)" />
      <line x1="18" y1="33" x2="30" y2="30" stroke="#7DD3B7" strokeWidth="1" strokeLinecap="round" transform="rotate(-12 14 22)" />
      <line x1="18" y1="38" x2="32" y2="35" stroke="#7DD3B7" strokeWidth="1" strokeLinecap="round" transform="rotate(-12 14 22)" />

      <rect x="118" y="14" width="22" height="28" rx="2" transform="rotate(10 118 14)" fill="#FFFFFF" stroke="#7DD3B7" strokeWidth="1.2" />
      <line x1="122" y1="20" x2="136" y2="22" stroke="#7DD3B7" strokeWidth="1" strokeLinecap="round" transform="rotate(10 118 14)" />
      <line x1="122" y1="25" x2="134" y2="27" stroke="#7DD3B7" strokeWidth="1" strokeLinecap="round" transform="rotate(10 118 14)" />
      <line x1="122" y1="30" x2="136" y2="32" stroke="#7DD3B7" strokeWidth="1" strokeLinecap="round" transform="rotate(10 118 14)" />

      <rect x="124" y="68" width="20" height="26" rx="2" transform="rotate(8 124 68)" fill="#FFFFFF" stroke="#7DD3B7" strokeWidth="1.2" />
      <line x1="128" y1="74" x2="140" y2="76" stroke="#7DD3B7" strokeWidth="1" strokeLinecap="round" transform="rotate(8 124 68)" />
      <line x1="128" y1="79" x2="138" y2="81" stroke="#7DD3B7" strokeWidth="1" strokeLinecap="round" transform="rotate(8 124 68)" />
      <line x1="128" y1="84" x2="140" y2="86" stroke="#7DD3B7" strokeWidth="1" strokeLinecap="round" transform="rotate(8 124 68)" />

      <circle cx="62" cy="98" r="3" fill="#FFFFFF" stroke="#7DD3B7" strokeWidth="1.2" />
      <line x1="62" y1="92" x2="62" y2="88" stroke="#7DD3B7" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
}
